import React from 'react';
import PropTypes from 'prop-types';

import Note from './Note';
import { Collapsible, Flex, mediaBreakpointMixin, TextButton, token } from '@zillow/constellation';
import styled from 'styled-components';

const ExpandPetNotesWrapper = styled.div`
  border-top: 1px solid ${token('colors.borderLight')};

  @media ${mediaBreakpointMixin('md')} {
    display: none;
  }
`;

export default function Notes({ applicants }) {
  const applicantsWithPetNotes = applicants.filter((applicant) => applicant.answers.pets?.description);

  if (applicantsWithPetNotes.length === 0) {
    return null;
  }

  const [firstApplicant, ...remainingApplicants] = applicantsWithPetNotes;
  if (remainingApplicants.length === 0) {
    return <Note firstName={firstApplicant.answers.firstName} note={firstApplicant.answers.pets.description} />;
  }

  return (
    <>
      <Note firstName={firstApplicant.answers.firstName} note={firstApplicant.answers.pets.description} />
      <Collapsible defaultCollapsed>
        {(collapsed, toggle) => {
          const notes = remainingApplicants.map((applicant) => (
            <Note
              key={applicant.userId}
              isMobileHidden={collapsed}
              firstName={applicant.answers.firstName}
              note={applicant.answers.pets.description}
            />
          ));

          return (
            <>
              {notes}
              <ExpandPetNotesWrapper>
                <Flex display="flex" justifyContent="center" marginTop="xs">
                  <TextButton onClick={toggle}>{collapsed ? 'See more' : 'See less'}</TextButton>
                </Flex>
              </ExpandPetNotesWrapper>
            </>
          );
        }}
      </Collapsible>
    </>
  );
}

Notes.propTypes = {
  applicants: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.string.isRequired,
      answers: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        pets: PropTypes.shape({
          description: PropTypes.string,
        }),
      }),
    }),
  ),
};
